import { rightRound } from '@/helpers/commonHelpers'

const gridMixins = {
  methods: {
    postProcessPopup({ePopup, eventSource}) {
      if (eventSource) {
        // const sourceTop = eventSource.getBoundingClientRect().top + window.scrollY;
        // ePopup.style.top = `${sourceTop + 5}px`;
      }
    }
  }
}

const updateTotalDataMixin = {
  methods: {
    async updateTotalDataWith(event, updateFunc) {
      const items = [];
      event.api.forEachNodeAfterFilterAndSort((item) => {
        if (item.data?.id) {
          const { data: { id } } = item
          items.push(id);
        }
      });
      const params = { ids: items.toString() }
      event.api.showLoadingOverlay();
      try {
        await updateFunc(params)
      } catch (e) {
        console.log(e)
      }
      event.api.hideOverlay();
    }
  }
}

const updateTotalDataOnFrontendMixin = {
  methods: {
    updateTotalData (event) {
      const totals = { ...this.totalData[0] }
      delete totals['date']
      for (const key in totals) {
        this.$set(totals, key, 0)
      }
      event.api.forEachNodeAfterFilterAndSort((item) => {
        for (const key in totals) {
          if (key !== 'date' && key in item.data) {
            totals[key] += item.data[key]
          }
        }
      });
      for (const key in totals) {
        const precision = key.includes('m3') ? 3 : 2
        this.$set(totals, key, rightRound(totals[key], precision))
      }
      this.$set(this.totalData, 0, totals)
    }
  }
}

export { gridMixins, updateTotalDataMixin, updateTotalDataOnFrontendMixin };



// WEBPACK FOOTER //
// ./src/mixins/index.js